module.exports = __webpack_public_path__ + "img/とにかく始める_議論.3004e87a.svg";